<div class="wk-sdm-da__header modal-header">
    <h3 class="wk-sdm-da__header-title modal-title">{{ title | translate }}</h3>
    <wk-icon-filled-close-sprite-pds3 />
    <icon-pds3 name="wk-icon-filled-close" color="#fff" (click)="bsModalRef.hide()" class="wk-sdm-da__header-close" />
</div>
<div class="wk-sdm-da__body modal-body">
    <div class="wk-sdm-da__body__form">
        <div class="wk-sdm-da__body__form-input">
            <label class="wk-sdm-da__body__form-input__label">{{ "Settings.UserHasAccess" | translate }}</label>
            <select-field-pds3 cg3-theme="PDS-v3" size="medium">
                <select [(ngModel)]="access" #name="ngModel" flow-id="select">
                    <option [ngValue]="undefined" [selected]="access == undefined" [disabled]="true" hidden>
                        {{ "Settings.ChooseAnOption" | translate }}
                    </option>
                    <option [ngValue]="true" [selected]="access === true">
                        {{ "General.Yes" | translate }}
                    </option>
                    <option [ngValue]="false" [selected]="access === false">
                        {{ "General.No" | translate }}
                    </option>
                </select>
            </select-field-pds3>
        </div>
    </div>
    <div class="wk-sdm-da__body__actions">
        <button
            class="btn-primary wk-sdm-da__body__actions-apply"
            (click)="submitForm(); bsModalRef.hide()"
            [disabled]="access == undefined || loading"
        >
            {{ "General.Apply" | translate }}
            @if (loading) {
                <app-loader [isOverlay]="false" size="button" />
            }
        </button>
        <button class="btn-secondary wk-sdm-da__body__actions-cancel" (click)="bsModalRef.hide()">{{ "Settings.btnCancel" | translate }}</button>
    </div>
</div>
